import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import intl from 'react-intl-universal';
import { DraftTeachingPath } from 'teachingPath/teachingPathDraft/TeachingPathDraft';
import { EditTeachingPathStore } from 'teachingPath/view/EditTeachingPath/EditTeachingPathStore';
import { DraftAssignment } from 'assignment/assignmentDraft/AssignmentDraft';
import { NewAssignmentStore } from 'assignment/view/NewAssignment/NewAssignmentStore';
import { CreateButton } from 'components/common/CreateButton/CreateButton';
import detailModalImg from 'assets/images/goals-white.svg';
import subject from 'assets/images/tags.svg';
import coreElement from 'assets/images/core.svg';
import multiSubject from 'assets/images/cogs.svg';
import goalsIcon from 'assets/images/goals.svg';
import './DetailsModal.scss';
// Rules this file renders with that live in other stylesheets; each page loads only its own CSS (#226).
import 'teachingPath/view/TeacherGuidance/TeacherGuidanceModal.scss';
import { injector } from 'Injector';
import { TeachingPathService, TEACHING_PATH_SERVICE } from 'teachingPath/service';
import { GenericGrepItem } from 'assignment/Assignment';
import { TeachingPath } from 'teachingPath/TeachingPath';
import { AssignmentService, ASSIGNMENT_SERVICE } from 'assignment/service';
import { handled } from 'utils/handled';

/*
 * eslint-disable-next-line is not enough here: dot-notation fires on a dozen reads.
 *
 * `state` is declared without its `State` annotation, so the initializer widens `goals`
 * to `never[]`. Every read of it goes through bracket access, which TypeScript does not
 * check — which is the only reason this file compiles. Annotating `state: State` makes
 * tsc report seven genuine nullability errors that have always been here.
 *
 * Left alone deliberately: it is a type fix in a component, not a linter change, and it
 * wants someone who knows what these goals are supposed to be.
 */
/* eslint-disable dot-notation */
const NumberTen = 10;
interface Props {
  isTeachingPath?: boolean;
  isAssignment?: boolean;
  editTeachingPathStore?: EditTeachingPathStore;
  currentEntityTeachingPath?: DraftTeachingPath;
  newAssignmentStore?: NewAssignmentStore;
  drafAssignment?: DraftAssignment;
  currentQuestionaryStore?: NewAssignmentStore;
  id?: number;
}

interface GoalsAux {
  gradeDesc: string | null | undefined;
  description: string;
}

interface GoalsInterface {
  subjectId: number;
  subjectDesc: string;
  goalsArray: Array<GoalsAux>;
}

interface State {
  isOpen: boolean;
  subjects: Array<string> | null;
  coreElements: Array<string> | null;
  multiSubjects: Array<string> | null;
  sources: Array<string> | null;
  goals: Array<GenericGrepItem> | null;
  entityTeachingPath: TeachingPath | undefined;
}

@inject('questionaryTeachingPathStore')
@inject('newAssignmentStore')
@observer

export class DetailsModal extends Component<Props, State> {
  private teachingPathService: TeachingPathService = injector.get(TEACHING_PATH_SERVICE);
  private assignmentService: AssignmentService = injector.get(ASSIGNMENT_SERVICE);
  public state = {
    isOpen: false,
    subjects: [],
    coreElements: [],
    multiSubjects: [],
    sources: [],
    goals: [],
    entityTeachingPath: undefined,

  };

  public componentDidMount() {

    handled(this.loadOnMount());

  }


  public async loadOnMount() {

    const { isTeachingPath, isAssignment } = this.props;
    if (isTeachingPath) {
      const response = await this.teachingPathService.getTeachingPathDataById(this.props.currentEntityTeachingPath!.id);
      let subjectItems = null;
      let coreElementItems = null;
      let multiSubjectItems = null;
      let sourceItems = null;
      let goalsItems = null;
      if (response !== null && response !== undefined) {
        this.setState({ entityTeachingPath: response });
        // `description || title`, as the assignment branch below reads `title`. This asserted
        // `description!`, and a teaching path's subjects come off the wire as `Array<Subject>`
        // with nothing guaranteeing one — so where it is missing, this showed a blank name.
        subjectItems = response.subjectItems.map(item => item.description || item.title);
        coreElementItems = response.coreElementItems.map(item => item.description);
        multiSubjectItems = response.multiSubjectItems.map(item => item.description);
        sourceItems = response.sourceItems.map(item => item.description);
        goalsItems = response.goalsItems.map(
          /* item => this.convertToGoal(item)); */
          item => item);
      }
      this.setState({
        subjects: subjectItems,
        coreElements: coreElementItems,
        multiSubjects: multiSubjectItems,
        sources: sourceItems,
        goals: goalsItems,
      });
    } else {
      if (isAssignment) {
        const response = this.props.drafAssignment! ? await this.assignmentService.getAssignmentById(this.props.drafAssignment.id) :
          await this.assignmentService.getAssignmentById(this.props.id!);
        /**
         * Empty arrays, not null.
         *
         * These are written to state as-is when the response is missing, and `render` reads
         * `subjects.length` and `coreElements.length` with no guard — so a details fetch that
         * returned nothing threw during render. A throw in render is caught by the pane's
         * ErrorBoundary and shown as a blank panel, with the cause only in the console.
         */
        let subjectItems: Array<string> = [];
        let coreElementItems: Array<string> = [];
        let multiSubjectItems: Array<string> = [];
        let sourceItems: Array<string> = [];
        let goalsItems: Array<GenericGrepItem> = [];
        if (response !== null && response !== undefined) {
          subjectItems = response.subjectItems.map(item => item.title);
          coreElementItems = response.coreElementItems.map(item => item.description);
          multiSubjectItems = response.multiSubjectItems.map(item => item.description);
          sourceItems = response.sourceItems.map(item => item.description);
          goalsItems = response.goalsItems.map(
            /*  */
            item => item);
        }
        this.setState({
          subjects: subjectItems,
          coreElements: coreElementItems,
          multiSubjects: multiSubjectItems,
          sources: sourceItems,
          goals: goalsItems,
        });
      }
    }
  }

  public openModalDetail = () => {
    this.setState({ isOpen: true });
    const breadcrumbsArray = Array.from(document.getElementsByClassName('CurrentAssignmentPage__mybreadcrumbs') as HTMLCollectionOf<HTMLElement>);
    if (breadcrumbsArray[0]) { breadcrumbsArray[0].style.display = 'none'; }
    if (breadcrumbsArray[1]) { breadcrumbsArray[1].style.display = 'none'; }
  }
  public closeModalDetail = () => {
    this.setState({ isOpen: false });
    const breadcrumbsArray = Array.from(document.getElementsByClassName('CurrentAssignmentPage__mybreadcrumbs') as HTMLCollectionOf<HTMLElement>);
    if (breadcrumbsArray[0]) { breadcrumbsArray[0].style.display = 'flex'; }
    if (breadcrumbsArray[1]) { breadcrumbsArray[1].style.display = 'flex'; }
  }
  public buttonOpenDetailsModal = () => (
      <CreateButton title={intl.get('generals.viewdetails')} onClick={this.openModalDetail}>
        <img src={detailModalImg} alt={intl.get('generals.viewdetails')} />
        {intl.get('generals.viewdetails')}
      </CreateButton>
    )
  public subjectRender = () => {
    const subjects = this.state.subjects ?? [];
    return (
      <div className="modalContentTG__body__item">
        <h3><img className="imgInfo" src={subject} /> {intl.get('preview.teaching_path.grep.subjects')}</h3>
        <ul className="modalContentTG__body__list">
          {subjects.map(item => <li key={item}>{item}</li>)}
        </ul>
      </div>
    );
  }
  public coreElementsRender = () => {
    const { coreElements } = this.state;
    return (
      <div className="modalContentTG__body__item">
        <h3><img className="imgInfo" src={coreElement} /> {intl.get('preview.teaching_path.grep.core_elements')}</h3>
        <ul className="modalContentTG__body__list">
          {coreElements.map(item => <li key={item}>{item}</li>)}
        </ul>
      </div>
    );
  }
  public multiSubjectsRender = () => {
    const { multiSubjects } = this.state;
    return (
      <div className="modalContentTG__body__item">
        <h3><img className="imgInfo" src={multiSubject} /> {intl.get('preview.teaching_path.grep.multidisciplinary_subjects')}</h3>
        <ul className="modalContentTG__body__list">
          {multiSubjects.map(item => <li key={item}>{item}</li>)}
        </ul>
      </div>
    );
  }
  public transformGoals = () => {
    const newGoalsArray: Array<GoalsInterface> = [];
    this.state.goals.forEach((goal) => {
      const newGoal = {} as GoalsInterface;
      const newGoals = {} as GoalsAux;
      const goalindex = newGoalsArray.map(e => e.subjectId).indexOf(goal['subjectId']);
      if (goalindex < 0) {
        newGoal.subjectId = goal['subjectId'];
        newGoal.subjectDesc = goal['subjectDesc'];
        newGoal.goalsArray = [];
        newGoals.gradeDesc = goal['gradeDesc'];
        newGoals.description = goal['description'];
        newGoal.goalsArray.push(newGoals);
        newGoalsArray.push(newGoal);
      } else {
        newGoals.gradeDesc = goal['gradeDesc'];
        newGoals.description = goal['description'];
        newGoalsArray[goalindex].goalsArray.push(newGoals);
      }
    });
    return newGoalsArray;
  }

  public goalsRender = () => {
    let classsubjectTitle = 'subjectTitle';
    if (this.transformGoals().length > 0) {
      this.transformGoals().forEach((e) => {
        if (e.goalsArray.length > 0) {
          e.goalsArray.forEach((ei) => {
            if (ei.gradeDesc!.length > NumberTen) {
              classsubjectTitle = 'subjectTitle subjectTitleCont';
            }
          });
        }
      });
    }
    return (
      <div className="modalContentTG__body__item">
        <h3><img className="imgInfo" src={goalsIcon} /> {intl.get('preview.teaching_path.grep.educational_goals')}</h3>
        <ul className="modalContentTG__body__listGoals">
        {this.transformGoals().map(item => <li key={item.subjectId}><div className={classsubjectTitle}>{item.subjectDesc}<div className="description"><ul>{item.goalsArray.map(li => <li key={item.subjectId} className="goalsItem"><div className="goalsItem__grade">{li.gradeDesc}</div><div className="goalsItem__description">{li.description}</div></li>)}</ul></div></div></li>)}
        </ul>
      </div>
    );
  }
  public contentDetailModal = () => {
    // Defaulted on read as well as on write: the state type still admits null, and a throw
    // here costs the whole panel.
    const subjects = this.state.subjects ?? [];
    const multiSubjects = this.state.multiSubjects ?? [];
    const coreElements = this.state.coreElements ?? [];
    const goals = this.state.goals ?? [];
    return (
      <div className="modalContentTG open">
        <div className="modalContentTG__header">
          <h1>{intl.get('generals.viewdetails_title')}</h1>
          <button className="modalContentTG__header__close" onClick={this.closeModalDetail}>
            <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path className="roundedCircle" fillRule="evenodd" clipRule="evenodd" d="M15.2476 0.9375C23.0138 0.9375 29.3101 7.23375 29.3101 15C29.3101 22.7663 23.0138 29.0625 15.2476 29.0625C7.48131 29.0625 1.18506 22.7663 1.18506 15C1.18506 7.23375 7.48131 0.9375 15.2476 0.9375Z" stroke="#0B2541" fill="white" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M9.62256 20.625L20.8713 9.375" stroke="#0B2541" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M20.8726 20.625L9.62134 9.375" stroke="#0B2541" strokeWidth="1.875" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
        <div className="modalContentTG__body">
          {subjects.length > 0 && this.subjectRender()}
          {coreElements.length > 0 && this.coreElementsRender()}
          {multiSubjects.length > 0 && this.multiSubjectsRender()}
          {/* {sources.length > 0 && this.sourcesRender()} */}
          {goals.length > 0 && this.goalsRender()}
        </div>
      </div>
    );
  }
  public backgroundDetailModal = () => (
      <div className="modalContentTGBackground" onClick={this.closeModalDetail} />
    )
  public render() {
    const subjects = this.state.subjects ?? [];
    const detailsclass = (subjects.length > 0) ? 'detailsModal marginLeft' : 'detailsModal';
    return (
      <div className={detailsclass}>
        {subjects.length > 0 && this.buttonOpenDetailsModal()}
        {this.state.isOpen && this.contentDetailModal()}
        {this.state.isOpen && this.backgroundDetailModal()}
      </div>
    );
  }
}
